import { createRouter, createWebHistory, type RouteLocationNormalizedGeneric } from 'vue-router'
import CaptchaView from '../views/CaptchaView.vue'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import VehicleView from '../views/VehicleView.vue'
import TypeView from '@/views/TypeView.vue'
import DetailsView from '@/views/DetailsView.vue'
import AddonsView from '@/views/AddonsView.vue'
import CustomerView from '@/views/CustomerView.vue'
import Payment from '@/views/Payment.vue'
import ConfirmView from '@/views/ConfirmView.vue'
import local from '@/stores/local'
import ManualVehicleView from '@/views/ManualVehicleView.vue'
import FinishView from '@/views/FinishView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue')
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: DefaultLayout,
      children: [
        {
          path: 'vehicle',
          name: 'vehicle',
          component: VehicleView,
          meta: {
            title: 'Dit køretøj',
            titleKey: 'vehicle_view_title' // dynamic text, overrides title
          }
        },
        {
          path: 'manual-vehicle',
          name: 'manual-vehicle',
          component: ManualVehicleView,
          meta: {
            title: 'Dit køretøj',
            titleKey: 'manual_vehicle_view_title' // dynamic text, overrides title
          }
        },
        {
          path: 'type',
          name: 'type',
          component: TypeView,
          meta: {
            title: 'Aftaletype'
          }
        },
        {
          path: 'details',
          name: 'details',
          component: DetailsView,
          meta: {
            title: 'Aftaleoplysninger'
          }
        },
        {
          path: 'payment',
          name: 'payment',
          component: Payment,
          meta: {
            title: 'Betaling'
          }
        },
        {
          path: 'addons',
          name: 'addons',
          component: AddonsView,
          meta: {
            title: 'Tillægsydelser'
          }
        },
        {
          path: 'customer',
          name: 'customer',
          component: CustomerView,
          meta: {
            title: 'Om dig'
          }
        },
        {
          path: 'confirm',
          name: 'confirm',
          component: ConfirmView,
          meta: {
            title: 'Tilbud'
          }
        },
        {
          path: 'finish',
          name: 'finish',
          component: FinishView
        },
      ],
      beforeEnter: [assertAuthenticated]
    },
    {
      path: '/captcha',
      name: 'captcha',
      component: CaptchaView,
      beforeEnter: assertAuthenticated
    },
  ],
})

async function assertAuthenticated(to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric) {
  let isAuthenticated = false
  const recaptchaResult = await local.getItem<string>('recaptcha')

  if (recaptchaResult) {
    isAuthenticated = true
  }

  if (to.name !== 'captcha' && !isAuthenticated) {
    return { name: 'captcha' }
  }

  else if (to.name === 'captcha' && isAuthenticated) {
    return { name: 'vehicle' }
  }
}

export default router
